<template>
  <div class="ckeditor4" >
    <textarea :id="id" ></textarea>
    <!--        <span @click="clearValue()" class="el-icon-circle-close closeBtn" v-if="value!=''"></span>-->
  </div>
</template>
<script>
/*eslint-disable*/
import baseUrl,{imageUrl} from "@/constants";
import guid from "@/common/guid";

export default {
  name: 'ckeditor',
  props: {
    'stopPast':{
      type: Boolean,
      default: true
    },
    'value': {
      type: String,
      default: "",
    },
    'basicstyles':{
      type: Array,
      default: () => ['Format','Font','FontSize','TextColor','Bold', 'Italic', '-', 'NumberedList', 'BulletedList', '-', '-','Image','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock']
    },
    'insert': {
      type: Array,
      default: () => [ 'SpecialChar']
    }
  },
  mounted: function () {
    this.basicstyles.push('clear');
    const _this = this // 渲染编辑器
    _this.ckeditor = window.CKEDITOR.replace(_this.id, {
      toolbar :[
        { name: 'basicstyles', items: this.basicstyles }
      ],
      extraPlugins:"clear",
      specialChars: this.specialChars,
      magicline_color : 'transparent',
      filebrowserUploadUrl: baseUrl + '/file/upload',
      fileTools_requestHeaders: this.headers,
      removeDialogTabs: 'image:advanced;',
      //移除title
      title: false,
      //允许imgBase64
      allowedContent:true,
      enterMode: CKEDITOR.ENTER_BR,
      shiftEnterMode: CKEDITOR.ENTER_BR,
      removePlugins: 'contextmenu,liststyle,tabletools,tableselection',
      readOnly: this.disabled
    })    // 设置初始内容
    _this.ckeditor.setData(_this.value)     // 监听内容变更事件
    _this.ckeditor.on('change', function () {
      _this.$emit('input', _this.ckeditor.getData())
    })
    _this.ckeditor.on('blur', function () {
      _this.$emit('input', _this.ckeditor.getData())
    })

      _this.ckeditor.on( 'fileUploadRequest', function( evt ) {
          var fileLoader = evt.data.fileLoader,
              formData = new FormData(),
              xhr = fileLoader.xhr;

          xhr.open( 'POST', fileLoader.uploadUrl, true );
          formData.append( 'file', fileLoader.file, fileLoader.fileName );
          formData.append('category', 'public')
          fileLoader.xhr.send( formData );
      });

    _this.ckeditor.on( 'fileUploadResponse', function( evt ) {
      evt.stop();
      var data = evt.data,
          xhr = data.fileLoader.xhr,
          response2 = JSON.parse(xhr.responseText);
        if (response2.data) {
           data.url = imageUrl+response2.data;
        }
    });

  },
  data: function () {
    return {
      id: guid(),
      ckeditor: null,
      headers:{ Authorization: this.$store.state.Authorization },
    }
  },
  methods:{
    clearValue(){
      this.ckeditor.setData("");
    }
  },
  watch: {     // 监听prop的变化，更新ckeditor中的值
    value: function () {
      if (this.value !== this.ckeditor.getData()) {
        this.ckeditor.setData(this.value)
      }
    }
  },
  // 销毁组件前，销毁编辑器
  beforeDestroy: function () {
    if(CKEDITOR.instances[this.id]){
      CKEDITOR.instances[this.id].destroy()
    }
  }
}
</script>
<style>
.ckeditor4{
  position: relative;
}
.ckeditor4 p{
  margin: 0 !important;
  padding: 0 10px !important;
}
.cke_editable{
  padding:0px 10px;
  line-height: 40px;
}
.cke_dark_background a{
  width: 30px!important;
}
.ckeditor4 .closeBtn{
  float: right;
  position: absolute;
  top: 14px;
  right: 10px;
  cursor: pointer;
  color: rgb(217,219,224);
}
</style>
